var site = site || {};

site.direction = site.direction || {};

(function ($, prodcat, site) {
  Drupal.behaviors.productImageFullV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-product-full__image', context);

      // Initialize all carousels.
      $modules.each(function () {
        var $module = $(this);
        var $fs_container = $('.js-product-full__image__main', $module);
        var $thumbs_container = $('.js-product-full__image__thumbs', $module);
        var $slides = $('.js-gallery-img-large', $fs_container);
        var $thumbs = $('.product-full__image__thumb', $thumbs_container);
        // vertical carouseling is a bit borked in this slick
        // so limiting max slides  so thumbnials dont overflow
        var max_slides = 6;

        $slides.slice(max_slides).remove();
        $thumbs.slice(max_slides).remove();
        $slides = $('.js-gallery-img-large', $fs_container);
        $thumbs = $('.product-full__image__thumb', $thumbs_container);

        var set_active_thumb = function (index) {
          $thumbs.removeClass('thumb-active');
          $thumbs_container.find('.slick-slide[index=' + index + ']').addClass('thumb-active');
        };
        // case for custom slides count and dots for mobile
        var settings = {
          rtl: site.direction.isRTL,
          slide: '.js-gallery-img-large',
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          asNavFor: $thumbs_container,
          autoplay: true,
          autoplaySpeed: 2000,
          // appendArrows: arrowsDiv,
          // appendDots: dotsDiv
          onBeforeChange: function (slick, currentSlide, nextSlide) {
            set_active_thumb(nextSlide);
          }
        };
        var thumb_settings = {
          rtl: site.direction.isRTL,
          slide: '.product-full__image__thumb',
          infinite: false,
          slidesToShow: $thumbs.length,
          slidesToScroll: 1,
          asNavFor: $fs_container,
          arrows: false,
          dots: false,
          vertical: true,
          focusOnSelect: true
        };

        $thumbs_container.not('.slick-initialized').slick(thumb_settings);
        // Init this carousel with our settings
        $fs_container.not('.slick-initialized').slick(settings);
        set_active_thumb(0);
      });
    }
  };
})(
  jQuery,
  window.prodcat || {},
  window.site || {}
);
